import produce from "immer";
import React, { FC, useState } from "react";
import { useDispatch } from "react-redux";
import { startEditElement } from "../../../actions/elementListAction";
import { Element } from "../../../models/elementModel";
import { HeadingType } from "../../../utils/constants";
import './elementProprtiesPanal.scss';
import Switch from "react-switch";


export interface HeadingElementPropertiesProps {
  element: Element;
}
const HeadingProperties: FC<HeadingElementPropertiesProps> = ({
  element,
}) => {
  const dispatch = useDispatch();
return (
    <div className="container mt-3">
      <div className="form-group row">
        <label htmlFor="elementName" className="col-sm-4 col-form-label font-size-12 align-text-left">
          Name
        </label>
        <div className="col-sm-8 items-align-left">
          <input
            value={`${element.name}`}
            className="form-control theam-textbox"
            onChange={(e) => {
              const newElement = produce(element, draft => { draft.name = e.target.value})
              dispatch(startEditElement(newElement));
            }}
            type="text"
            id="elementName"
          />
        </div>
      </div>
      <div className="form-group row">
        <label htmlFor="heading-txt" className="col-sm-4 col-form-label font-size-12 align-text-left">
          Heading Text
        </label>
        <div className="col-sm-8">
          <input
            value={element.properties.text}
            className="form-control theam-textbox items-align-left"
            onChange={(e) => {
              const newElement = produce(element, draft => { draft.properties.text = e.target.value})
              dispatch(startEditElement(newElement));
            }}
            type="text"
            id="heading-txt"
          />
        </div>
      </div>
      <div className="form-group row">
        <label htmlFor="heading-type" className="col-sm-4 col-form-label font-size-12 align-text-left">
          Heading Type
        </label>
        <div className="col-sm-8">
          <select
            value={element.properties.headingType}
            id="heading-type"
            className="form-control theam-textbox items-align-left"
            onChange={(e) => {
              const newElement = produce(element, draft => { draft.properties.headingType = e.target.value})
              dispatch(startEditElement(newElement));
            }}
          >{
            HeadingType.map((item, i) => {
                  switch (item.value) {
                    case 'h1':
                      return(
                        <option className="h1" key={i} value={item.value}>
                          {item.name}
                        </option>
                      );
                    case 'h2':
                      return(
                        <option className="h2" key={i} value={item.value}>
                          {item.name}
                        </option>
                      );
                    case 'h3':
                      return(
                        <option className="h3" key={i} value={item.value}>
                          {item.name}
                        </option>
                      );
                    case 'h4':
                      return(
                        <option className="h4" key={i} value={item.value}>
                          {item.name}
                        </option>
                      );
                    case 'h5':
                      return(
                        <option className="h5" key={i} value={item.value}>
                          {item.name}
                        </option>
                      );
                    case 'h6':
                      return(
                        <option className="h6" key={i} value={item.value}>
                          {item.name}
                        </option>
                      );
                    default:
                      return null;
                  }

              })
          }
          </select>
        </div>
      </div>
      <div className="form-group row">
        <label htmlFor="btn-outline" className="col-sm-4 col-form-label font-size-12 align-text-left">
          Display
        </label>
          <div className="col-sm-2 mt-1">
            <Switch
              checked={element.properties.display}
              onChange={() =>{
                const newElement = produce(element, draft => {
                  draft.properties.display = !draft.properties.display;
                })
                dispatch(startEditElement(newElement));
              }}
              onColor="#86d3ff"
              onHandleColor="#2693e6"
              handleDiameter={15}
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              height={10}
              width={24}
              className="react-switch"
              id="btn-outline"
             />
          </div>
      </div>
      <div className="form-group row">
      <label htmlFor="tooltip" className="col-sm-4 col-form-label font-size-12 align-text-left">
        Tooltip
      </label>
        <div className="col-sm-8">
          <textarea className="form-control theam-textbox font-size-12 items-align-left" name="tooltip" id="tooltip" placeholder="Enter tooltip" cols={30} rows={2}
          value={element.properties.tooltip}
            onChange={(e) => {
              const newElement = produce(element, draft => { draft.properties.tooltip = e.target.value})
              dispatch(startEditElement(newElement));
            }}
          ></textarea>
        </div>
      </div>
    </div>
  );
};

export default HeadingProperties;
